var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-card',{attrs:{"flat":""}},[_c('CompanyEmployeeList',{attrs:{"nextTo":"CompanyEmployeePermissions","nextIcon":"$sl-permissions","type":"employed","title":_vm.$t('labels.permissions')}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }